import "./App.css";

function App() {
  return (
    <div className="under-construction">
      <div className="container">
        <h1 className="title">Site is Under Construction?</h1>
        <p className="subtitle">We're working on something amazing!</p>
        <p className="message">Please check back soon please! 🐟</p>
      </div>
    </div>
  );
}

export default App;
